import React, { useState } from "react";
import "../css/ContactScreen.css";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import emailjs from "emailjs-com";
import fire from "../config/fire";
import { getDatabase, ref, set, onValue } from "firebase/database";
import LoaderComponent from "../component/LoaderComponent";
import { sendEmail } from "../component/emailService";
import ContactUsFormComp from "../component/ContactUsFormComp";

emailjs.init("C48u70GDz5s6uyPcS");
const ContactScreen = () => {
	const [formData, setFormData] = useState({
		companyName: "",
		name: "",
		email: "",
		phone: "",
		country: "",
		quantity: "",
		isInterested: "", // YES / NO dropdown
		message: "",
	});
	const [loader, setLoader] = useState(false);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoader(true);
		const db = getDatabase();
		sendEmail({
			from_name: formData.name,
			from_email: formData.email,
			companyName: formData.companyName,
			country: formData.country,
			quantity: formData.quantity,
			phone: formData.phone,
			isInterested: formData.isInterested, // ✅ added
			message: formData.message,
		}).then(
			async () => {
				await set(ref(db, `customerquery/${Date.now().toString()}`), {
					...formData,
				});
				toast.success("Message sent successfully!");
				setFormData({
					companyName: "",
					name: "",
					email: "",
					phone: "",
					country: "",
					quantity: "",
					isInterested: "",
					message: "",
				});
				setLoader(false);
			},
			(error) => {
				toast.warn("Failed to send message. Try again!");
				console.error(error);
				setLoader(false);
			},
		);
	};

	return (
		<div className="contact-container">
			{loader ? <LoaderComponent /> : ""}
			<ToastContainer />
			<div className="contact-wrapper">
				<div className="contact-image">
					<FaEnvelopeOpenText />
				</div>

				<div className="contact-card">
					<h2>Contact Us</h2>
					<p>We’d love to hear from you 👋</p>
					<ContactUsFormComp />
				</div>
			</div>
		</div>
	);
};

export default ContactScreen;
